import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Flex, Space, Typography, theme } from 'antd';
import {
  SEARCH_PERFORMANCE_PLAN_COPY,
  SearchPerformanceCtaRow,
  useSearchPerformancePlanLabel,
} from '~features/SearchPerformance';

import { useSelector, useUserRole } from '../../hooks/usePrerenderUser';
import USER_ROLES from '../auth/userRoles';
import { dates } from '~library/dates';
import { SEARCH_PERFORMANCE_CARD_DESCRIPTION, SEARCH_PERFORMANCE_CARD_TITLE } from './SearchPerformanceCardCopy';

const MANAGE_SUBSCRIPTION_HREF = '/billing/plans';

type Props = {
  onReactivate: () => void;
};

function SearchPerformanceCancelledCard({ onReactivate }: Props) {
  const { token } = theme.useToken();
  const planName = useSearchPerformancePlanLabel();
  const cancelledAt = useSelector((state) => state.prerenderUser.cancelledAt);
  const userRole = useUserRole();

  const isRestrictedBillingRole = [USER_ROLES.GUEST, USER_ROLES.TEAM_MEMBER].includes(userRole);
  const endedOn = cancelledAt ? dates.dayOfPointInTime(cancelledAt) : null;
  const message = [
    SEARCH_PERFORMANCE_PLAN_COPY.cancelled(planName, endedOn),
    ...(isRestrictedBillingRole ? [SEARCH_PERFORMANCE_PLAN_COPY.contactAccountOwner] : []),
  ].join(' ');

  return (
    <Card
      title={SEARCH_PERFORMANCE_CARD_TITLE}
      styles={{ body: { paddingTop: token.padding, paddingBottom: token.padding } }}
    >
      <Flex vertical gap={token.marginXXS}>
        <Typography.Text>{SEARCH_PERFORMANCE_CARD_DESCRIPTION}</Typography.Text>
        <SearchPerformanceCtaRow message={message}>
          {!isRestrictedBillingRole && (
            <Space direction="vertical" size={4} align="center" style={{ flexShrink: 0 }}>
              <Button type="primary" onClick={onReactivate}>
                {SEARCH_PERFORMANCE_PLAN_COPY.reactivate(planName)}
              </Button>
              <Link style={{ color: token.colorPrimary }} to={MANAGE_SUBSCRIPTION_HREF}>
                {SEARCH_PERFORMANCE_PLAN_COPY.manageSubscription}
              </Link>
            </Space>
          )}
        </SearchPerformanceCtaRow>
      </Flex>
    </Card>
  );
}

export default SearchPerformanceCancelledCard;
